import React from 'react'
import { cm } from '../../utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  description?: string
  error?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, description, error, leftIcon, rightIcon, className, ...props }, ref) => {
    const hasError = !!error

    return (
      <div className='flex flex-col gap-1 w-full'>
        {label && (
          <label className='text-sm font-medium text-tokens-neutral-text-primary select-none'>
            {label}
          </label>
        )}

        <div className='relative'>
          {leftIcon && (
            <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
              {leftIcon}
            </div>
          )}

          <input
            ref={ref}
            className={cm(
              'w-full px-3 py-2 text-base rounded-[12px] border transition-colors',
              'bg-tokens-neutral-bg-white text-tokens-neutral-text-primary placeholder:text-tokens-neutral-text-placeholder',
              'focus:outline-none focus:ring-1 focus:ring-tokens-primary-2',
              hasError
                ? 'border-tokens-status-error-1'
                : 'border-tokens-neutral-border-1 hover:border-tokens-primary-2',
              leftIcon ? 'pl-10' : '',
              rightIcon ? 'pr-10' : '',
              className
            )}
            {...props}
          />

          {rightIcon && (
            <div className='absolute inset-y-0 right-0 flex items-center pr-3 select-none'>
              {rightIcon}
            </div>
          )}
        </div>

        {description && !hasError && (
          <p className='text-xs text-tokens-neutral-text-secondary select-none'>{description}</p>
        )}
        {hasError && <p className='text-xs text-tokens-status-error-1 select-none'>{error}</p>}
      </div>
    )
  }
)

Input.displayName = 'Input'
export default Input
